import Vue from "vue";
Vue.mixin({
  data(){
    return {
      path: process.env.VUE_APP_TU,
      defaultImg:require('@/assets/img/error-img.png'),
    }
  },
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    }
  }
})